import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import 'vant/lib/index.css';

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// VueCookies.config('1h');//1h
VueCookies.config('6m');//6个月
Vue.use(VueCookies);
Vue.prototype.$bus = new Vue();
//百度统计
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?b4a04f9c8cba2467b12046afc5d87a93"
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts
// 全局文件
import global_ from './common/Global'//引用文件
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面
Vue.config.productionTip = false;
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
